import { render } from "./JurisdictionManagementIcon.vue?vue&type=template&id=0b404ec4"
const script = {}

import exportComponent from "/home/vsts/work/r1/a/_Build/release/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__